var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconParticipants = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .participants_a {\n                fill: none !important;\n            }\n\n            .participants_b {\n                fill: #fff;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "participants_a",
    d: "M0,0H32V32H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "participants_b",
    d: "M11.392,16.927C8.252,16.927,2,18.522,2,21.7v2.385H20.783V21.7C20.783,18.522,14.531,16.927,11.392,16.927Zm-6.252,4.43a12.783,12.783,0,0,1,6.252-1.7,12.783,12.783,0,0,1,6.252,1.7Zm6.252-6.815A4.771,4.771,0,1,0,6.7,9.771,4.739,4.739,0,0,0,11.392,14.542Zm0-6.815A2.045,2.045,0,1,1,9.379,9.771,2.026,2.026,0,0,1,11.392,7.726Zm9.445,9.283a5.734,5.734,0,0,1,2.63,4.689v2.385h5.367V21.7C28.833,18.944,24.137,17.377,20.837,17.009Zm-1.4-2.467a4.771,4.771,0,0,0,0-9.542,4.563,4.563,0,0,0-2.012.477,7.541,7.541,0,0,1,0,8.587A4.563,4.563,0,0,0,19.442,14.542Z",
    transform: "translate(0.583 1.458)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconParticipants);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon_Participants.46975d725ddfd5f37741b11eece8a333.svg";